import React from 'react';

import CatalogShell from './CatalogShell';

/**
 * Canonical field registry — cross-tenant logical field names (e.g.
 * `member_id`, `subscriber_id`) that the canonical mapping surface binds
 * tenant-specific columns to. `data_type` drives downstream coercion.
 */
const CanonicalFields: React.FC = () => (
  <CatalogShell
    slug="canonical-fields"
    title="Canonical fields"
    breadcrumbLabel="Canonical fields"
    emptyBody="Canonical fields are the platform-wide logical field registry. Tenants map their source-specific columns to these names."
    addCtaLabel="Add first canonical field"
    extraColumns={[
      {
        name: 'data_type',
        label: 'Data type',
        type: 'select',
        options: ['STRING', 'INTEGER', 'DECIMAL', 'BOOLEAN', 'DATE', 'TIMESTAMP', 'JSON'],
        width: 140,
      },
    ]}
  />
);

export default CanonicalFields;
